export const BASE_URL =
  "https://panel.multigraharadhika.co.id/uploads/product_homepage";
